/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_DescInputs */



/**
* | output |
* | --- |
* | "Connect to third-party services for enhanced functionality" |
*
* @param {Options_Integrations_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_desc = /** @type {((inputs?: Options_Integrations_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectez des services tiers pour des fonctionnalités avancées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbinden Sie sich mit Diensten von Drittanbietern, um die Funktionalität zu erweitern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Connettiti a servizi di terze parti per funzionalità avanzate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подключайтесь к сторонним сервисам для расширения функциональности.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conéctese a servicios de terceros para obtener una funcionalidad mejorada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("连接第三方服务以增强功能")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サードパーティのサービスに接続して機能を強化する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बेहतर कार्यक्षमता के लिए तृतीय-पक्ष सेवाओं से जुड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conecte-se a serviços de terceiros para obter funcionalidades aprimoradas.")
	return /** @type {LocalizedString} */ ("Connect to third-party services for enhanced functionality")
});